var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1179_8347)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.499999C15.1826 0.499999 18.2348 1.76428 20.4853 4.01472C22.7357 6.26515 24 9.3174 24 12.5C24 15.6826 22.7357 18.7348 20.4853 20.9853C18.2348 23.2357 15.1826 24.5 12 24.5V24.5C8.8174 24.5 5.76515 23.2357 3.51472 20.9853C1.26428 18.7348 7.70842e-07 15.6826 1.04907e-06 12.5C1.3273e-06 9.3174 1.26428 6.26515 3.51472 4.01472C5.76516 1.76428 8.8174 0.499999 12 0.499999Z",
    fill: "#D1F178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62494 13.0623L17.0174 13.0623L13.3799 16.6923C13.2896 16.8016 13.2432 16.9407 13.2499 17.0824C13.2566 17.2241 13.3159 17.3582 13.4162 17.4585C13.5165 17.5588 13.6506 17.6181 13.7923 17.6249C13.934 17.6316 14.0731 17.5852 14.1824 17.4948L18.8699 12.8073C18.974 12.6996 19.0321 12.5558 19.0321 12.406C19.0321 12.2563 18.974 12.1125 18.8699 12.0048L14.1824 7.31729C14.0731 7.21663 13.9298 7.16075 13.7812 7.16075C13.6325 7.16075 13.4893 7.21663 13.3799 7.31729C13.2759 7.42497 13.2178 7.56883 13.2178 7.71854C13.2178 7.86826 13.2759 8.01212 13.3799 8.11979L17.2049 11.9373L5.62494 11.9373C5.47576 11.9373 5.33268 11.9966 5.22719 12.102C5.1217 12.2075 5.06244 12.3506 5.06244 12.4998C5.06244 12.649 5.1217 12.7921 5.22719 12.8975C5.33268 13.003 5.47576 13.0623 5.62494 13.0623Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1179_8347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 24.5) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.413122104bb6115fab17ee823df968b0.svg";
export { ForwardRef as ReactComponent };